var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModuleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82031 1.875H5.57031C6.23335 1.875 6.86924 2.13839 7.33808 2.60723C7.80692 3.07607 8.07031 3.71196 8.07031 4.375V13.125C8.07031 12.6277 7.87277 12.1508 7.52114 11.7992C7.16951 11.4475 6.69259 11.25 6.19531 11.25H1.82031V1.875Z",
    stroke: "#0F172A",
    strokeWidth: 1.03556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3203 1.875H10.5703C9.90727 1.875 9.27139 2.13839 8.80255 2.60723C8.3337 3.07607 8.07031 3.71196 8.07031 4.375V13.125C8.07031 12.6277 8.26786 12.1508 8.61949 11.7992C8.97112 11.4475 9.44803 11.25 9.94531 11.25H14.3203V1.875Z",
    stroke: "#0F172A",
    strokeWidth: 1.03556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleIcon);
export default __webpack_public_path__ + "static/media/ModuleIcon.8906ea164f1ce7a5d31066d8bbcfcb6a.svg";
export { ForwardRef as ReactComponent };